import script from "./QuizOption.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizOption.vue?vue&type=script&setup=true&lang=js"

import "./QuizOption.vue?vue&type=style&index=0&id=51aa6419&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51aa6419"]])

export default __exports__